import axios from "axios";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";

export const SET_LOADING = "saga/membershipRevenue/SET_LOADING";
export const SET_PREV_PAGE_FILTERS = "saga/membershipRevenue/SET_PREV_PAGE_FILTERS";
export const FETCH_CURRENT_USER = "saga/membershipRevenue/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/membershipRevenue/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/membershipRevenue/FETCH_CURRENT_USER_FAILURE";
export const UPDATE_ALL_DATA = "saga/membershipRevenue/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/membershipRevenue/UPDATE_ALL_DATA_SUCCESS";
export const UPDATE_ALL_DATA_FAILURE = "saga/membershipRevenue/UPDATE_ALL_DATA_FAILURE";
export const FETCH_MEMBERSHIP_DRAFT_SUCCESS =
  "saga/membershipRevenue/FETCH_MEMBERSHIP_DRAFT_SUCCESS";
export const FETCH_MEMBERSHIP_DRAFT_FAILURE =
  "saga/membershipRevenue/FETCH_MEMBERSHIP_DRAFT_FAILURE";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
}

export function* getCurrentUserData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: payload.user });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date, prevRevenueType: payload.revenue_type }
  });
  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);

  try {
    yield getMembershipDraft({
      short_url,
      organization_id,
      date: payload.date,
      revenue_type: payload.revenue_type
    });
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date, prevRevenueType: payload.revenue_type }
  });

  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);

  try {
    yield getMembershipDraft({
      short_url,
      organization_id,
      date: payload.date,
      revenue_type: payload.revenue_type
    });
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getMembershipDraft(params) {
  try {
    const res = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/membership_revenue/revenues",
      { params }
    );
    yield put({ type: FETCH_MEMBERSHIP_DRAFT_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERSHIP_DRAFT_FAILURE, error });
  }
}
